import * as React from "react";
import PrismTsx from "react-syntax-highlighter/dist/esm/languages/prism/tsx";
import { default as SyntaxHighlighter } from "react-syntax-highlighter/dist/esm/prism-light";
import PrismStyle from "react-syntax-highlighter/dist/esm/styles/prism/tomorrow";
import { onlyText } from 'react-children-utilities';

SyntaxHighlighter.registerLanguage("tsx", PrismTsx);

export interface IAccessibleCodeBlockProps {
    /**
     * String that corresponds to the class name of the language to be used for syntax highlighting.
     */
    language: string;
    /**
     * Enforces that the children of this component is a string.
     */
    children: string | string[];
}

class AccessibleCodeBlock extends React.Component<IAccessibleCodeBlockProps> {
    public render() {
        const CustomPre = (props: any) => <pre tabIndex="0" {...props} />;

        return (
            <SyntaxHighlighter language={this.props.language} style={PrismStyle} PreTag={CustomPre}>
                {onlyText(this.props.children)}
            </SyntaxHighlighter>
        );
    }
}

export default AccessibleCodeBlock;
